<template>
  <div class="navbar navbar-default navbar-fixed-top" role="navigation" style="background-color: #ffffff;">
    <div class="navbar-header">
      　
      <!-- .navbar-toggle样式用于toggle收缩的内容，即nav-collapse collapse样式所在元素 -->
      <button class="navbar-toggle" type="button" data-toggle="collapse" data-target=".navbar-responsive-collapse" >
        <span class="sr-only">Toggle Navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <!-- 确保无论是宽屏还是窄屏，navbar-brand都显示 -->
      <a href="http://www.hnwdba.com:8088/wd/login" class="navbar-brand" target="_blank">
        <img src="../../assets/logohead.png" style="width: 77px;height: 30px;margin-top: -5px;" class="img-responsive">
      </a>

    </div>
    <!-- 屏幕宽度小于768px时，div.navbar-responsive-collapse容器里的内容都会隐藏，显示icon-bar图标，当点击icon-bar图标时，再展开。屏幕大于768px时，默认显示。 -->
    <div class="collapse navbar-collapse navbar-responsive-collapse row">
      <ul class="nav navbar-nav col-md-10">
        <li>
          <router-link to="/">网站首页</router-link>
        </li>
        <li>
          <router-link to="/dszzc">董事长致辞</router-link>
        </li>
        <li>
          <router-link to="/gsjj">公司简介</router-link>
        </li>
        <li>
          <router-link to="/wdjf">威盾技防</router-link>
        </li>
        <li>
          <router-link to="/fwfw">服务范围</router-link>
        </li>
        <li>
          <router-link to="/xmzs">项目展示</router-link>
        </li>
        <li>
          <router-link to="/wdtb">威盾特保</router-link>
        </li>
        <li class="hidden-md hidden-lg">
          <router-link to="/xwdt">新闻动态</router-link>
        </li>
        <li class="hidden-md hidden-lg">
          <router-link to="/bzzl">报纸专栏</router-link>
        </li>
        <li class="hidden-md hidden-lg">
          <router-link to="/hyxw">行业新闻</router-link>
        </li>
        <li class="dropdown hidden-xs">
         <a href="javascript:void(0);" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="backcolor">新闻咨询<b class="caret"></b></a>
          <ul class="dropdown-menu text-center">
            <li >
              <router-link to="/xwdt">新闻动态</router-link>
            </li>
            <li >
              <router-link to="/bzzl">报纸专栏</router-link>
            </li>
            <li >
              <router-link to="/hyxw">行业新闻</router-link>
            </li>
          </ul>
        </li>
        <li>
          <router-link to="/lxwm">联系我们</router-link>
        </li>
        <li class="navbar-right hidden-xs" style="margin-top: 4px;text-align: left;color: #777777;">
         苗总：18703679018 
          <br>
         电话：0371-86677877
        </li>
      </ul>


    </div>
  </div>
  <!-- <div class="row  headpadding" >
    <div class="col-md-1 text-right">
      <a href="http://www.hnwdba.com:8088/wd/login" target="_blank">
      <img src="../../assets/logohead.png" style="width: 77px;height: 30px;" class="img-responsive">
      </a>
    </div>
    <div class="col-md-8 texttop text-left">
      <ul class="list-inline ulleft">
        <li><router-link to="/">网站首页</router-link></li>
        <li><router-link to="/dszzc">董事长致辞</router-link></li>
        <li><router-link to="/gsjj">公司简介</router-link></li>
        <li><router-link to="/wdjf">威盾技防</router-link></li>
        <li><router-link to="/fwfw">服务范围</router-link></li>
        <li><router-link to="/xmzs">项目展示</router-link></li>
        <li><router-link to="/wdtb">威盾特保</router-link></li>
        <li>
          <div class="dropdown">
           <a href="javascript:void(0);" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="backcolor">新闻咨询<b class="caret"></b></a>
            <div style="height: 10px;"></div>
            <ul class="dropdown-menu " style="margin-top: 0px;">
              <li><router-link to="/xwdt">新闻动态</router-link></li>
              <li><router-link to="/bzzl">报纸新闻</router-link></li>
              <li><router-link to="/hyxw">保安在线</router-link></li>
            </ul>
          </div>

        </li>
        <li><router-link to="/lxwm">联系我们</router-link></li>
      </ul>
    </div>
    <div class="col-md-3 text-center">
      <div class="row">
        <div class="col-md-3 text-right" style="margin-top: 8px;padding-right: 0px;">电话:</div>

      <div class="col-md-9 text-left" style="margin-top: -3px;">
        苗总(18703679018)<br>办公室(0371-86677877)

      </div>
      </div>
      </div>
  </div> -->

</template>


<script>
  export default {
    name: 'HeadNav',
    data() {
      return {

      }
    },
    mounted() {
      // $('.dropdown').mouseover(function() {
      //   $(this).addClass('open');
      // }).mouseout(function() {
      //   $(this).removeClass('open');
      // });
      // $('#backcolor').click(function(e) {
      //   e.stopPropagation();
      // });

    },
    methods: {}
  }
</script>

<style>
  .headpadding {
    width: 100%;
    padding: 15px 0px 0px 10px;
    color: #595959;
    margin-left: 0px;
    position: fixed;
    top: 0px;
    z-index: 999;
    background-color: rgb(255, 255, 255);
  }

  .ulleft li {
    margin-left: 10px;
  }

  a {
    color: #595959;
    text-decoration: none;
  }

  a:hover {
    color: #595959;
    text-decoration: none;
  }

  a:link {
    color: #595959;
    text-decoration: none;
  }

  a:active {
    color: #595959;
  }

  a:visited {
    color: #595959;
  }

  .texttop {
    margin-top: 5px;
  }

  .row {
    margin-left: 0px;
    margin-right: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/headNav.vue